import type { Ride } from '../domain/ride';
import type { UnitSystem } from '../domain/measurement-units';
import { filenamePart } from '../../../renderer/src/download-filename';
export type { VideoPresentation } from '../../../renderer/src/video-presentation';

export type RouteImageTreatment = 'terra-terrain';
export type RouteImageAspectRatio = '16:9' | '4:5';

export interface RouteImageRecipe {
  readonly treatment: RouteImageTreatment;
  readonly aspectRatio: RouteImageAspectRatio;
  readonly rotation: number;
  readonly tilt: number;
  readonly terrainHeight: number;
  readonly unitSystem: UnitSystem;
}

export const IMAGE_FORMATS = {
  '16:9': { width: 2400, height: 1350 },
  '4:5': { width: 1920, height: 2400 },
} as const;
export const TREATMENTS = [
  { id: 'terra-terrain', label: 'Terra + terrain' },
] as const;

export function defaultImageRecipe(unitSystem: UnitSystem): RouteImageRecipe {
  return { treatment: 'terra-terrain', aspectRatio: '16:9', rotation: 0, tilt: 45, terrainHeight: 1.15, unitSystem };
}

export function imageFilename(ride: Ride, treatment: RouteImageTreatment, aspectRatio: RouteImageAspectRatio = '16:9'): string {
  const suffix: Record<RouteImageTreatment, string> = { 'terra-terrain': 'TerraTerrain' };
  return `${filenamePart(ride.title, 100) || 'Trace'}_${suffix[treatment]}_${aspectRatio.replace(':', 'x')}.png`;
}
